/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import store from '../store'

export default {
  fetchModules ({ commit }) {
    const customModules = [
      {
        hash: Math.random(),
        name: 'Empresas',
        typeId: 1,
        icon: 'CloudIcon',
        createdAt: '01/02/2021 00:23',
        typeName: 'Database basic'
      },
      {
        hash: Math.random(),
        name: 'Documentos',
        typeId: 2,
        icon: 'ClipboardIcon',
        createdAt: '01/02/2021 00:34',
        typeName: 'Memory'
      },
      {
        hash: Math.random(),
        name: 'Colaboradores',
        typeId: 3,
        icon: 'UsersIcon',
        createdAt: '01/02/2021 00:46',
        typeName: 'Memory Single Row'
      }
    ]

    commit('SET_MODULES', customModules)
  },
  saveChanges ({commit}, payload) {

    
  }
}
